import { useEffect, useState } from 'react';
import { bootLocale, getLocale, subscribeLocale } from './index';

// Applies <html lang/dir> from the phone's browser language. No picker.
export default function I18nProvider({ children }) {
  const [, setLocaleTick] = useState(getLocale());

  useEffect(() => {
    bootLocale();
    return subscribeLocale((next) => setLocaleTick(next));
  }, []);

  return children;
}
